export default __webpack_public_path__ + "static/media/logo.e6eb0edf.png";